import {CheckboxSwitch} from "../checkbox/checkboxSwitch";
import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import {Table} from "@tanstack/react-table";

type ColumnSettingsProps<T> = {
    table: Table<T>;
}

const toggleAllColumnsSwitchId = "toggle-all-columns";

const TableColumnSettings = <T, >({table}: ColumnSettingsProps<T>) => {
    return (
        <div>
            <div className="margin-bottom-s padding-bottom-s border-bottom">
                <CheckboxSwitch
                    id={toggleAllColumnsSwitchId}
                    label={Localizer.dashboard_toggleAllColumns()}
                    onChange={table.getToggleAllColumnsVisibilityHandler()}
                    value={table.getIsAllColumnsVisible()}
                    reverseTextAndSwitch
                />
            </div>
            {table.getAllLeafColumns().map(column => {
                return <div key={column.id} className="margin-bottom-s padding-bottom-xs border-bottom">
                    <CheckboxSwitch
                        id={column.id}
                        disabled={!column.getCanHide()}
                        label={column.columnDef.header as string}
                        onChange={() => column.toggleVisibility()}
                        value={column.getIsVisible()}
                        reverseTextAndSwitch
                    />
                </div>
            })}
        </div>
    )
}
export default TableColumnSettings;
